import React, { PropTypes, Component } from "react";
import { inject, observer } from "mobx-react";
import {Form} from 'reactstrap';
import qs from 'query-string';
import DataWrapper from "../../../principal/containers/DataWrapper";
import _ from 'lodash';
import ParametrosGeraisStore from "../../../administracao/stores/ParametrosGeraisStore";
import {Redirect} from "react-router-dom";
import {FormWithActions} from "../../../comum/components/FormWithActions";
import {DetalhamentoSolicitante} from "../../comum/components/DetalhamentoSolicitante";
import {DetalhamentoEmpregadosSubstituidos} from "../../comum/components/DetalhamentoEmpregadosSubstituidos";
import {DetalhamentoIndicacoes} from "../../comum/components/DetalhamentoIndicacoes";
import {DetalhamentoContato} from "../../comum/components/DetalhamentoContato";
import {DetalhamentoCargo} from "../../comum/components/DetalhamentoCargo";
import {DetalhamentoJustificativaExcecao} from "../../comum/components/DetalhamentoJustificativaExcecao";
import {DetalhamentoDebito} from "../../comum/components/DetalhamentoDebito";
import {DetalhamentoLocais} from "../../comum/components/DetalhamentoLocais";
import {DetalhamentoJustificativa} from "../../comum/components/DetalhamentoJustificativa";
import {DetalhamentoPrazos} from "../../comum/components/DetalhamentoPrazos";
import {DetalhamentoPerfil} from "../../comum/components/DetalhamentoPerfil";
import {DetalhamentoCPFDiferente} from "../../solicitacao_ett/components/DetalhamentoCPFDiferente";
import {DetalhamentoDadosMOT} from "../../solicitacao_ett/components/DetalhamentoDadosMOT";
import {DetalhamentoSalarioDiferente} from "../../solicitacao_ett/components/DetalhamentoSalarioDiferente";
import {DetalhamentoAlterarDataInicio} from "../../solicitacao_ett/components/DetalhamentoAlterarDataInicio";
import {DetalhamentoContratosAnterioresEValidacoes} from "../../comum/components/DetalhamentoContratosAnterioresEValidacoes";
import {DetalhamentoHistoricoFluxo} from "../../comum/components/DetalhamentoHistoricoFluxo";
import {DadosTerminoAntecipado} from "../components/DadosTerminoAntecipado";
import AndamentoTAStore from "../stores/AndamentoTAStore";
import {DetalhamentoProrrogacoesAnteriores} from "../../comum/components/DetalhamentoProrrogacoesAnteriores";
import {LoadingPanel} from "../../../comum/components/LoadingPanel";


@inject("store")
@DataWrapper
@observer
export class DetalhesAndamentoTA extends Component {
    constructor(props) {
        super(props);
        this.state = this.props.store.appStore;
        this.loginStore = this.props.store.loginStore;
        this.formStore = this.props.store.formStore;
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
        this.validacaoStore = this.props.store.validacaoStore;
        this.modalStore = this.props.store.modalStore;
        this.loadingPanelStore = this.props.store.loadingPanelStore;


        this.parametrosGeraisStore = new ParametrosGeraisStore();

        this.controller = new AndamentoTAStore(this.parametrosGeraisStore, this.loginStore, this.tituloPaginaStore, this.validacaoStore, this.modalStore,this.loadingPanelStore);
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Detalhamento término antecipado");

        const solicitacaoId = _.get(this.props, "match.params.solicitacaoId");
        const solicitacaoEttId = _.get(this.props, "match.params.solicitacaoEttId");
        const terminoAntecipadoId = _.get(this.props, "match.params.terminoAntecipadoId");
        const queryParams = qs.parse(this.props.location.search);
        const idFluxo = queryParams.idFluxo;

        this.controller.carregarLista({solicitacaoId: solicitacaoId, solicitacaoEttId: solicitacaoEttId, terminoAntecipadoId: terminoAntecipadoId, idFluxo: idFluxo});

        //this.parametrosGeraisStore.carregarLista();
    }

    static propTypes = {
        label: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.array,
            PropTypes.object,
        ])
    };

    render() {

        if (this.formStore.acaoEnviada) {
                if (this.formStore.nomeAcao === "forcarAprovacao")
                    return <Redirect to="/solicitacao-andamento" />;
            }
        const desabilitarValidacao = this.validacaoStore.desabilitarValidacao

        return (
            <div>
                <div className="form-wrapper">
                    <LoadingPanel>
                        <div className="content-panel panel-sm">
                            <Form className="panel-form">
                                <FormWithActions controller={this.controller} taskId={_.get(this.props, "match.params.taskIdBpm")} solicitacaoExcecao={this.controller.isSolicitacaoExcecao}
                                             tarefa={this.controller.nomeTarefa} fluxo={this.controller.nomeFluxo} possiveisAcoes={this.controller.possiveisAcoes}
                                             error={this.formStore.submitted && !this.modalStore.exibirModal.aberto && !this.validacaoStore.isValidForm}>
                                    {this.controller.exibeJustificativaExcecao &&
                                        <DetalhamentoJustificativaExcecao />
                                    }
                                    <DetalhamentoSolicitante />
                                    <DetalhamentoContato desabilitarValidacao={desabilitarValidacao} />
                                    <DetalhamentoLocais />
                                    {this.controller.exibeDebito &&
                                        <DetalhamentoDebito />
                                    }
                                    <DetalhamentoJustificativa />
                                    <DetalhamentoEmpregadosSubstituidos />
                                    <DetalhamentoPrazos />
                                    {this.controller.exibeDetalhamentoTerminoAntecipado &&
                                    <DadosTerminoAntecipado />
                                    }
                                    <DetalhamentoCargo />
                                    <DetalhamentoPerfil />
                                    {this.controller.exibeIndicacoes &&
                                        <DetalhamentoIndicacoes />
                                    }
                                    {this.controller.exibeDetalhamentoCPFDiferente &&
                                        <DetalhamentoCPFDiferente desabilitarValidacao={desabilitarValidacao} />
                                    }
                                    {this.controller.exibeDetalhamentoDadosMOT &&
                                        <DetalhamentoDadosMOT desabilitarValidacao={desabilitarValidacao} />
                                    }
                                    {this.controller.exibeDetalhamentoSalarioDiferente &&
                                        <DetalhamentoSalarioDiferente desabilitarValidacao={desabilitarValidacao} />
                                    }
                                    {this.controller.exibeDetalhamentoAlterarDataInicio &&
                                        <DetalhamentoAlterarDataInicio desabilitarValidacao={desabilitarValidacao}/>
                                    }
                                    { this.controller.exibeContratosAnterioresEValidacoes &&
                                        <DetalhamentoContratosAnterioresEValidacoes/>
                                    }
                                    <DetalhamentoProrrogacoesAnteriores titulo={"Prorrogações realizadas"} textoNenhumResultado={"Nenhuma prorrogação realizada"} />
                                    {this.controller.exibeDetalhamentoHistorico &&
                                        <DetalhamentoHistoricoFluxo />
                                    }
                                </FormWithActions>
                            </Form>
                        </div>
                    </LoadingPanel>
                </div>
            </div>
        )
    }
}